import { useCallback } from 'react';
import type React from 'react';

import { ClientRender } from '@change-corgi/core-react/ssr/render';

import { LazyComponent, ScrollableComponent } from '#src/app/shared/components/layout/lazy';
import { useIsBot } from '#src/app/shared/hooks/userAgent';

import { TrendingSectionSkeleton } from '../skeletons';
import { TrendingSection } from '../TrendingSection';

export const LazyTrendingSection: React.FC<EmptyProps> = () => {
	const isBot = useIsBot();
	const loadComponent = useCallback(
		async () =>
			(await import(/* webpackChunkName: "pages/homepage-trendingSection" */ '../TrendingSection')).TrendingSection,
		[],
	);

	// Crawlers that don't run JS never get past the skeleton below, so for bots the section
	// is rendered straight into the SSR output from the data prefetched in page context.
	// Humans keep the scroll-gated render so its images don't cost anyone who never scrolls
	// this far. The static import above for the bot branch means the section's code now ships
	// in the main homepage bundle for everyone; it's small, so that's an accepted trade-off.
	if (isBot) return <TrendingSection />;

	return (
		<ClientRender placeholder={<TrendingSectionSkeleton />}>
			<ScrollableComponent topOffset={200} immediateForBots fallback={<TrendingSectionSkeleton />}>
				<LazyComponent loadComponent={loadComponent} fallback={<TrendingSectionSkeleton />} />
			</ScrollableComponent>
		</ClientRender>
	);
};
